import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Basemap, FOREST_LAYERS, OverlayState } from './forest-layers';

let nextGroupId = 0;

@Component({
  selector: 'app-layers-panel',
  imports: [TranslateModule],
  templateUrl: './layers-panel.component.html',
  styleUrl: './layers-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'mapboxgl-ctrl' },
})
export class LayersPanelComponent {
  readonly state = input.required<OverlayState>();
  readonly showWhisp = input(false);
  readonly showWhispDebug = input(false);
  readonly whispStale = input(false);
  readonly stateChange = output<OverlayState>();

  readonly forestLayers = FOREST_LAYERS;
  readonly settingsOpen = signal(false);
  readonly basemapGroup = `basemap-${nextGroupId++}`;

  toggleSettings(): void {
    this.settingsOpen.update((open) => !open);
  }

  toggleWhisp(): void {
    this.emit({ whisp: !this.state().whisp });
  }

  toggleWhispDebug(): void {
    this.emit({ whispDebug: !this.state().whispDebug });
  }

  toggleForest(id: string): void {
    this.emit({ forest: { ...this.state().forest, [id]: !this.state().forest[id] } });
  }

  chooseBasemap(basemap: Basemap): void {
    this.emit({ basemap });
  }

  changeOpacity(event: Event): void {
    this.emit({ opacity: Number((event.target as HTMLInputElement).value) });
  }

  private emit(change: Partial<OverlayState>): void {
    this.stateChange.emit({ ...this.state(), ...change });
  }
}
